import { ApprovalStatus, ApprovalUserType, ApprovalStepStatus, ApprovalOperation, ApprovalTypes } from 'ui-product-approvals-common';
import { canRejectApproval } from './canRejectApproval';
import { canRequestChanges } from './canRequestChanges';
export const getAvailableOperations = ({
  configEnabled,
  isLoading,
  approvalStatus,
  approvalConcluded,
  hasApprovalData,
  currentUserType,
  stepStatusForCurrentUser,
  hasApproveScope,
  approvalType,
  restartOnConclude
}) => {
  if (!configEnabled || isLoading) {
    return [];
  }
  const canCancelApproval = approvalType !== ApprovalTypes.DEAL;
  switch (approvalStatus) {
    case ApprovalStatus.APPROVAL_PENDING:
      if (currentUserType === ApprovalUserType.APPROVER && stepStatusForCurrentUser === ApprovalStepStatus.APPROVAL_PENDING) {
        return [ApprovalOperation.APPROVE, ...(canRejectApproval({
          approvalType
        }) ? [ApprovalOperation.REJECT] : []), ...(canRequestChanges({
          approvalType
        }) ? [ApprovalOperation.REQUEST_CHANGES] : []), ...(hasApproveScope && canCancelApproval ? [ApprovalOperation.CANCEL] : [])];
      } else if (currentUserType === ApprovalUserType.REQUESTER || hasApproveScope) {
        return canCancelApproval ? [ApprovalOperation.CANCEL] : [];
      }
      return [];
    case ApprovalStatus.CHANGES_REQUESTED:
      if (currentUserType === ApprovalUserType.APPROVER && (stepStatusForCurrentUser === ApprovalStepStatus.APPROVAL_PENDING || stepStatusForCurrentUser === ApprovalStepStatus.CHANGES_REQUESTED)) {
        return [ApprovalOperation.APPROVE, ...(canRejectApproval({
          approvalType
        }) ? [ApprovalOperation.REJECT] : []), ...(canRequestChanges({
          approvalType
        }) ? [ApprovalOperation.REQUEST_CHANGES] : []), ...(hasApproveScope && canCancelApproval ? [ApprovalOperation.CANCEL] : [])];
      } else if (currentUserType === ApprovalUserType.REQUESTER || hasApproveScope) {
        return canCancelApproval ? [ApprovalOperation.CANCEL] : [];
      }
      return [];

    // Approval not started - treat the same as CANCELLED.
    case undefined:
    case ApprovalStatus.CANCELLED:
      if (approvalType !== ApprovalTypes.QUOTE) {
        return [ApprovalOperation.REQUEST];
      }
      return [];
    case ApprovalStatus.APPROVED:
      if (restartOnConclude && hasApprovalData && approvalConcluded && approvalType !== ApprovalTypes.QUOTE) {
        return [ApprovalOperation.REQUEST];
      }
      return [];
    case ApprovalStatus.REJECTED:
      if (approvalType === ApprovalTypes.CONNECTED_APP) {
        return [ApprovalOperation.REQUEST];
      }
      return [];
    default:
      return [];
  }
};